/* ==========================================================================
   Hero flavour cycle — fallback for browsers without scroll-driven animation
   ==========================================================================
   sv-motion.css cycles the hero band and cross-fades the three serve shots
   using animation-timeline. Chrome and Edge support it; Safari, including
   every iPhone, does not, so on those the hero sat on one flavour and never
   changed — which is what "the colour animation does not work on mobile"
   was describing.

   Where the CSS mechanism is unavailable this drives the same three beats on
   a timer instead of on scroll. A timer rather than a scroll listener is
   deliberate: the CSS version pins a 260vh hero to give the scroll somewhere
   to travel, and that is a lot of thumb work on a phone. The beats and the
   colours are the same either way.

   Does nothing when the browser supports the CSS version, when the visitor
   asks for reduced motion, or when the hero is off screen.
   ========================================================================== */
(function () {
  'use strict';

  var supportsScrollTimeline =
    window.CSS &&
    CSS.supports &&
    (CSS.supports('animation-timeline: view()') || CSS.supports('animation-timeline', 'view()'));
  if (supportsScrollTimeline) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;

  var hero = document.querySelector('.a-hero');
  if (!hero) return;

  var serves = Array.prototype.slice.call(hero.querySelectorAll('.a-hero__serve'));
  if (serves.length < 2) return;

  /* Matches the keyframes in sv-motion.css beat for beat. */
  var BEATS = ['passionfruit', 'peach', 'lemon'];
  var HOLD = 3600;

  hero.classList.add('a-hero--jscycle');

  var i = 0;
  var timer = null;

  function paint() {
    hero.setAttribute('data-flavour', BEATS[i]);
    serves.forEach(function (img, n) {
      img.classList.toggle('is-on', n === i);
    });
  }

  function advance() {
    i = (i + 1) % Math.min(BEATS.length, serves.length);
    paint();
  }

  function start() {
    if (timer) return;
    timer = window.setInterval(advance, HOLD);
  }
  function stop() {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  }

  paint();

  /* Only run while the hero is actually on screen, and stop when the tab is
     hidden — a background timer repainting a section nobody is looking at is
     wasted battery on the device this exists for. */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.15 }).observe(hero);
  } else {
    start();
  }

  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : start();
  });

  /* If the visitor turns reduced motion on mid-session, settle and stop. */
  var onReduce = function () {
    if (reduce.matches) { stop(); i = 0; paint(); }
  };
  reduce.addEventListener ? reduce.addEventListener('change', onReduce) : reduce.addListener(onReduce);
})();
